import { ReactComponent as AddIcon } from '../../components/icons/add-icon.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { ReactComponent as TwoPeople } from '../../components/icons/two-people.svg';
import { ReactComponent as SearchIcon } from '../../components/icons/search.svg';
import { ReactComponent as DingDong } from '../../components/icons/ding-dong.svg';
import SortArrows from '../../components/icons/sort-arrows.jsx';
import CustomButton from '../../components/components/custom_button/customButton.jsx';
import CustomInput from '../../components/components/custom_input/customInput.jsx';
import store from '../../store/store.js'; // Import magazynu Redux
import { clearCheckedItems, toggleNeedRefresh, setKeyword, setSearchValue} from '../../store/notificartionsTabSlice.js';
import ApiService from '../../components/api_services/apiService';

// Akcje dla tabeli użytkowników
export const actions = {  
  // addSport: () => {
  //   console.log('Dodaj sport kliknięte');
  //   handleOpenModal;
  //   // Logika otwierania modala lub przekierowania do formularza dodawania sportu
  // },
 deleteSelected: async (dispatch) => {
    // Pobierz `checkedItems` ze stanu Redux    
    const state = store.getState();
    const selectedIds = state.notifications.checkedItems;    

    if (selectedIds.length === 0) {
      alert('Nie wybrano żadnych elementów do usunięcia.');
      return;
    }

    try {
      const response = await ApiService.deleteNotifByIdList(selectedIds);

      // Obsługa odpowiedzi serwera
      if (response.status === 200) {
        alert('Wszystkie notyfikacje zostały usunięte!');
      } else if (response.status === 206) {
        alert('Niektóre notyfikacje nie mogły zostać usunięte!');
      } else if (response.status === 204) {
        alert('Nie znaleziono notyfikacji do usunięcia!');
      }

      // Wyzerowanie zaznaczonych elementów
      dispatch(clearCheckedItems());
      dispatch(toggleNeedRefresh());

    } catch (error) {      
      console.error('Błąd podczas usuwania notyfikacji:', error);
      alert('Wystąpił błąd podczas usuwania notyfikacji.');
    }
  },
  // searchUsers: (query) => {
  //   console.log('Wyszukaj użytkowników:', query);
  //   // Logika wyszukiwania użytkowników
  // },
  // changeTab: (tabName, dispatch, setActiveUsersTab) => {
  //   console.log('Zmieniono zakładkę na:', tabName);
  //   dispatch(setActiveUsersTab(tabName));
  // },
};

// Konfiguracja nagłówków tabeli

export const getHeaders = (sortBy, sortDirection, dispatch, setSorting, sortArrowColorActive, sortArrowColorInactive, rowsSports, checkedItems) => [
  <input
    type="checkbox"
    checked={rowsSports.every((row) => checkedItems.includes(row[1]))}
    onChange={(e) => {
      if (e.target.checked) {
        // Dodaj wszystkie widoczne elementy do checkedItems
        rowsSports.forEach((row) => {
          if (!checkedItems.includes(row[1])) {
            dispatch({ type: 'notifications/toggleCheckedItem', payload: row[1] });
          }
        });
      } else {
        // Usuń wszystkie widoczne elementy z checkedItems
        rowsSports.forEach((row) => {
          if (checkedItems.includes(row[1])) {
            dispatch({ type: 'notifications/toggleCheckedItem', payload: row[1] });
          }
        });
      }
    }}
    />,
    <div className="table-columns-headers">
    <div>ID</div>
    <SortArrows
      upColor={sortBy === 'id' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'id' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'id') {
          dispatch(setSorting({ sortBy: 'id', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'id', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Typ notyfikacji</div>
    <SortArrows
      upColor={sortBy === 'notification_type' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'notification_type' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'notification_type') {
          dispatch(setSorting({ sortBy: 'notification_type', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'notification_type', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Kontent w j.angielskim</div>
    <SortArrows
      upColor={sortBy === 'content_eng' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'content_eng' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'content_eng') {
          dispatch(setSorting({ sortBy: 'content_eng', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'content_eng', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
    <div className="table-columns-headers">
    <div>Kontent w j.polskim</div>
    <SortArrows
      upColor={sortBy === 'content_pl' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'content_pl' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'content_pl') {
          dispatch(setSorting({ sortBy: 'content_pl', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'content_pl', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,

  <div className="table-columns-headers">Nadawca</div>,
  <div className="table-columns-headers">Odbiorca</div>,

  <div className="table-columns-headers">
    <div>Push</div>  
        <SortArrows
          upColor={sortBy === 'push_enabled' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
          downColor={sortBy === 'push_enabled' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
          className="menu-icon"
          onClick={() => {
            if (sortBy !== 'push_enabled') {
              dispatch(setSorting({ sortBy: 'push_enabled', sortDirection: 'ASC' }));
            } else {
              if (sortDirection === 'ASC') {
                dispatch(setSorting({ sortBy: 'push_enabled', sortDirection: 'DESC' }));
              } else {
                dispatch(setSorting({ sortBy: null, sortDirection: null }));
              }
            }
          }}
        />  
  </div>,
  <div className="table-columns-headers">
    <div>Aktywność</div>
    <SortArrows
      upColor={sortBy === 'enabled' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'enabled' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'enabled') {
          dispatch(setSorting({ sortBy: 'enabled', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'enabled', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
  <div>Akcje</div>
</div>,
];

export const empty = [];

// Szerokości kolumn
export const headerWidths = ['42px', '65px', '220px', '2fr', '2fr', '95px', '95px', '80px', '120px', '100px'];

// Konfiguracja zakładek
export const tabsConfig = (activeUsersTab, dispatch, setActiveUsersTab) => [
  {
    icon: DingDong,
    name: 'Notyfikacje',
    hoverClass: 'hover-effect',
    activeClass: activeUsersTab === 'Dyscypliny' ? 'is-active' : '',
    onClick: () => {},
    toggleActive: true,
  },
];

// Konfiguracja przycisków
export const buttonsConfig = ( toggleAddModal ) => [  
  {
    icon: AddIcon,
    name: 'Dodaj notyfikację',
    baseClass: 'custom-button-black',
    hoverClass: 'hover-effect',
    activeClass: '',
    onClick: () => {
      toggleAddModal();
    },
    toggleActive: false,
  },
];

// Konfiguracja lewej strony
export const leftSideConfig = (dispatch) => [
  {
    component: CustomButton,
    props: {
      icon: Trash,
      name: 'Usuń zaznaczone',
      baseClass: 'custom-button-white',
      hoverClass: 'hover-effect',
      activeClass: '',
      borders: 'LRBT',
      onClick: () => actions.deleteSelected(dispatch), // Przekaż tutaj zaznaczone ID użytkowników
      toggleActive: false,
    },
  },
];

// Konfiguracja prawej strony
export const rightSideConfig = (searchValue, dispatch) => [
  {
    component: CustomInput,
    props: {
      icon: SearchIcon,
      placeholder: 'Wyszukaj',
      hoverClass: 'hover-effect',
      borders: 'LRBT',
      bordersClassPrefix: 'border-black-',
      baseClass: 'custom-input',
      activeClass: '',
      value: searchValue,
      onChange: (e) => {
        e.preventDefault();
        let value = e.target.value;
        let actualSearch = store.getState().notifications.searchValue; // Pobierz aktualną wartość wyszukiwania z Redux
        let keyword = store.getState().notifications.keyword; // Pobierz aktualne słowo kluczowe z Redux
        if (value === actualSearch) {
           return; // Jeśli wartość się nie zmieniła, nie aktualizuj stanu
        } else {
          dispatch(setSearchValue(value)); // Ustaw wartość wyszukiwania w stanie lokalnym
          if (keyword !== value && (value.length >= 3 || value.length === 0)) {
            dispatch(setKeyword(value)); // Aktualizuj stan w Reduxie
            dispatch(toggleNeedRefresh()); // Przełącz flagę odświeżenia
          }
        }
      },
    },
  },
];